export const normalizeContact = (contact) => {
  if (!contact) {
    return { countryCode: '', number: '' };
  }

  if (typeof contact === 'object' && !Array.isArray(contact)) {
    return {
      countryCode: String(contact.countryCode ?? '').trim(),
      number: String(contact.number ?? '').trim(),
    };
  }

  const value = String(contact).trim();
  const match = value.match(/^(\+\d{1,4})\s*(.+)$/);

  if (match) {
    return {
      countryCode: match[1],
      number: match[2].replace(/\s+/g, '').trim(),
    };
  }

  return {
    countryCode: '',
    number: value.replace(/\s+/g, '').trim(),
  };
};

export const formatContact = (contact) => {
  const normalized = normalizeContact(contact);
  if (!normalized.countryCode && !normalized.number) {
    return '-';
  }
  return normalized.countryCode ? `${normalized.countryCode} ${normalized.number}` : normalized.number;
};